export const CLIENTS_TYPES = {
  ru: [
    {
      id: 0,
      name: 'Все',
    },
    {
      id: 1,
      name: 'Физлицо',
    },
    {
      id: 2,
      name: 'Юрлицо',
    },
    {
      id: 3,
      name: 'Реферал',
    },
  ],
  en: [
    {
      id: 0,
      name: 'All',
    },
    {
      id: 1,
      name: 'Individual',
    },
    {
      id: 2,
      name: 'Entity',
    },
  ],
};
